import { get, sortBy } from 'lodash-es';

export const FALLBACK_CATEGORY = 'Features';
export const FALLBACK_FEATURES_NUM = 10;
export const TOP_FEATURES_NUM = 5;

export const CATEGORIES = [
  {
    title: 'Comfort & Convenience',
    featureCategoryFields: ['comfort_convenience'],
    icon: 'icon-audio_steering_wheel_control',
  },
  {
    title: 'Entertainment',
    featureCategoryFields: ['entertainment'],
    icon: 'icon-mobile_internet',
  },
  {
    title: 'Safety',
    featureCategoryFields: ['safety'],
    icon: 'icon-shield-check',
  },
  {
    title: 'Engine & Exterior',
    featureCategoryFields: ['engine', 'exterior', 'engine_exterior'],
    icon: 'icon-car',
  },
  {
    title: FALLBACK_CATEGORY,
    featureCategoryFields: [],
    icon: 'icon-cog2',
  },
];

export function getFeaturesByCategories(vinData) {
  const derivedGenericFeatures = sortBy(get(vinData, 'derivedGenericFeatures', []), [
    feature => feature.optionText.toLowerCase(),
  ]);
  const featuresByCategories = {};

  CATEGORIES.forEach(({ title, featureCategoryFields }) => {
    const features = derivedGenericFeatures.filter(({ featureCategory }) =>
      featureCategoryFields.includes(featureCategory)
    );
    if (features.length) {
      featuresByCategories[title] = features;
    }
  });

  return featuresByCategories;
}

export function getTopFeatures(vinData) {
  return sortBy(get(vinData, 'derivedGenericFeatures', []), ['displayPriority']).slice(0, TOP_FEATURES_NUM);
}

export function getFallbackFeatures(options) {
  return {
    [FALLBACK_CATEGORY]: options.map(option => ({ optionText: option })).slice(0, FALLBACK_FEATURES_NUM),
  };
}
